module.exports = __webpack_public_path__ + "static/media/05.1d44ed12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/05.jpg
// module id = 25
// module chunks = 0